var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('timeline',{ref:"timeline",attrs:{"db":"jobs","sortimenter":"machines","property":"machine","methods":{ getColor: _vm.getColor }}})}
var staticRenderFns = []

export { render, staticRenderFns }